module.exports = __webpack_public_path__ + "static/img/taide-art-navbar-black.c7b4681.png";